import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import React, { FC } from 'react'

const SuggestionChipsForService: FC<{
  values: { id: number, name: string }[]
  selectedValues: { id: number, name: string }[]
  onToggle: (value: { id: number, name: string }) => void
  legendBackground?: string
}> = ({ values, selectedValues, onToggle, legendBackground }) => (
  <div className="condition_suggestions">
    <span className="condition_suggestions_legend" style={{ backgroundColor: legendBackground }}>予測候補</span>
    {
      values.map((value) => {
        const isActive = selectedValues.map((v) => v.id).includes(value.id)
        return (
          <button
            type="button"
            className={`suggestion_chip ${isActive ? "active" : ""}`}
            key={`suggestion_${value.name}`}
            onClick={() => onToggle(value)}
          >
            <FontAwesomeIcon icon={['fas', isActive ? 'check' : 'plus']} fixedWidth />
            {value.name}
          </button>
        )
      })
    }
  </div>
)

export default SuggestionChipsForService
